import { Injectable } from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class MetaTagsService {

  currentPageTitle = "";
  private readonly SUFFIX = " | Berufsreise Tirol";
  private defaultRobots: string | null = null;
  constructor(
    private title: Title,
    private meta: Meta
  ) { }

  updateTitle(title: string, skipSuffix = false) {
    let newTitle = title;
    if(!skipSuffix) {
      newTitle += (" " + this.SUFFIX);
    }
    this.title.setTitle(newTitle);
    this.currentPageTitle = newTitle;
    this.meta.updateTag({ property: 'og:title', content: newTitle })
  }

  updateOgUrl(url: string) {
    this.meta.updateTag({ name: 'og:url', content: url })
  }

  updateDescription(desc: string) {
    this.meta.updateTag({ name: 'description', content: desc })
  }

  setNoIndex() {
    // remember the default robots value from index.html to restore it later
    if (this.defaultRobots === null) {
      this.defaultRobots = this.meta.getTag("name='robots'")?.content ?? "";
    }
    this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });
  }

  removeNoIndex() {
    if (this.defaultRobots === null) {
      return;
    }

    if (this.defaultRobots.length) {
      this.meta.updateTag({ name: 'robots', content: this.defaultRobots });
    } else {
      this.meta.removeTag("name='robots'");
    }
    this.defaultRobots = null;
  }

  getCurrentPageTitle(): string {
    return this.currentPageTitle;
  }
}
